import { styled } from "../gatsby-theme-stitches/config"

export const Stack = styled("div", {
  variants: {
    space: {
      xs: {
        "> *": {
          mb: "$xs",
        },
      },
      s: {
        "> *": {
          mb: "$s",
        },
      },
      m: {
        "> *": {
          mb: "$m",
        },
      },
      l: {
        "> *": {
          mb: "$m",
          "@desktop": {
            mb: "$l",
          },
        },
      },
      xl: {
        "> *": {
          mb: "$l",
          "@desktop": {
            mb: "$xl",
          },
        },
      },
      xxl: {
        "> *": {
          mb: "$xl",
          "@desktop": {
            mb: "$xxl",
          },
        },
      },
    },
  },
})
